/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { serverTimestamp } from "firebase/firestore";
import ModelAdd from "../../components/products/model/ModelAdd";
import ModelShow from "../../components/products/model/ModelShow";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ProductExportModal from "./ProductExportModal";
import AiGeneratedProductsTable from "../../components/products/DataTableTemplatingDemo/AiGeneratedProductsTable";
import {
  MoreVertical,
  Edit,
  Trash2,
  Plus,
  Folder,
  Sparkles,
  Wand2,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import AILandingPageModal from "../../components/products/model/AILandingPageModal";
import { addMultipleProducts } from "../../redux/products/productsActions";
import { auth } from "../../firebase";
import { updateAccount } from "../../redux/account/account";
import AiGenerationHistory from "../../components/products/DataTableTemplatingDemo/AiGenerationHistory";

const GENERATE_LANDING_ENDPOINT =
  "https://backend.foorweb.net/api/v1/foorAiModel/landingPage/generate-landing";

// Loading Component
const ProjectSkeleton = () => (
  <div
    className="bg-white rounded-xl border border-[#fbf4ff] shadow-sm overflow-hidden 
    dark:!bg-[#181819] dark:!border-[#3c3a3d]"
  >
    <div
      className="aspect-[4/3] bg-gradient-to-br from-purple-100 to-purple-200 
      dark:from-[#2a2a2c] dark:to-[#3c3a3d]"
    ></div>
    <div className="p-4">
      <div
        className="h-5 bg-gradient-to-r from-purple-200 to-purple-300 rounded mb-2 
        dark:from-[#3a3a3c] dark:to-[#4a4a4d]"
      ></div>
      <div className="flex items-center justify-between">
        <div
          className="h-4 bg-purple-100 rounded w-20 
          dark:bg-[#3c3a3d]"
        ></div>
        <div className="bg-[#fcf6ff] px-2 py-1 rounded-lg dark:bg-[#2a2a2c]">
          <div
            className="h-3 bg-purple-200 rounded w-10 
            dark:bg-[#4a4a4d]"
          ></div>
        </div>
      </div>
    </div>
  </div>
);

// Empty State Component
const EmptyState = ({ t }) => (
  <div className="col-span-full flex flex-col items-center justify-center py-16">
    <div className="w-24 h-24 bg-gradient-to-br from-purple-100 to-purple-200 rounded-full flex items-center justify-center mb-6">
      <Folder className="w-12 h-12 text-[#9e68ba]" />
    </div>
    <h3 className="text-xl font-bold text-[#9e68ba] mb-2">
      {t("foorAi.projectCenter.emptyState.title")}
    </h3>
    <p className="text-gray-600 text-center max-w-md">
      {t("foorAi.projectCenter.emptyState.description")}
    </p>
  </div>
);

// Small "browser card" used to build the stacked landing-page preview in the hero
const HeroMockupCard = ({
  rotate = 0,
  z = 10,
  emphasize = false,
  className = "",
}) => (
  <div
    className={`w-40 sm:w-52 rounded-xl bg-white dark:bg-[#1f1f21] border border-purple-100 dark:border-[#3c3a3d] overflow-hidden ${
      emphasize ? "shadow-2xl" : "shadow-lg"
    } ${className}`}
    style={{ transform: `rotate(${rotate}deg)`, zIndex: z }}
  >
    <div className="h-20 sm:h-24 bg-gradient-to-br from-purple-200 to-purple-300 dark:from-[#3a2a3f] dark:to-[#2a2a2c]" />
    <div className="p-3 space-y-2">
      <div className="h-2 w-3/4 bg-purple-200 dark:bg-[#3c3a3d] rounded-full" />
      <div className="h-2 w-1/2 bg-purple-100 dark:bg-[#2a2a2c] rounded-full" />
      <div className="flex gap-1 pt-1">
        <div className="h-7 w-7 rounded-md bg-purple-100 dark:bg-[#2a2a2c]" />
        <div className="h-7 w-7 rounded-md bg-purple-100 dark:bg-[#2a2a2c]" />
        <div className="h-7 w-7 rounded-md bg-purple-100 dark:bg-[#2a2a2c]" />
      </div>
    </div>
  </div>
);

function Products() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("landing"); // "landing" | "history"
  const [lgShow, setLgShow] = useState(false);
  const [modelShow, setModelShow] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);
  const [data2, setData2] = useState(["", "", "", "", ""]);
  const [templates, setTemplates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const products = useSelector((state) => state.ProductsReducer);
  const [aiModalShow, setAiModalShow] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);

  const [images, setImages] = useState([
    {
      original: "https://picsum.photos/id/1018/1000/600/",
      thumbnail: "https://picsum.photos/id/1018/250/150/",
    },
  ]);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  const [data, setData] = useState({
    name: "",
    image: "",
    review: "",
    price: "",
    oldPrice: "",
    comment: "",
    qty: "",
    category_id: "",
    sku: "",
    show: "1",
    short: "",
    options: [
      {
        title: "1",
        color: "1",
        colorOption: [
          {
            option: "",
            color: "",
          },
        ],
      },
    ],
    discount: {
      freeDelivery: true,
      discountDelivery: 0,
      discountTotal: 0,
    },
    offers: [
      { title: "", qty: 0, price: 0 },
      { title: "", qty: 0, price: 0 },
      { title: "", qty: 0, price: 0 },
      { title: "", qty: 0, price: 0 },
    ],
    gallery: [],
    textEditor: "<p><br></p>",
    timeStamp: serverTimestamp(),
  });

  const message = () => {
    const MySwal = withReactContent(Swal);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success mx-2",
        cancelButton: "btn btn-danger mx-2",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: `<a href="https://m.me/F0orweb" target="_blank">${t(
          "foorAi.contact.free_trial_title",
        )}</a>`,
        showCancelButton: true,
        confirmButtonText: t("foorAi.contact.yes"),
        cancelButtonText: t("foorAi.contact.no"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.open("https://m.me/F0orweb", "_blank", "noopener,noreferrer");
        }
      });
  };

  const handleAdd = () => {
    setData({
      ...data,
      name: "",
      image: "",
      review: "",
      price: "",
      oldPrice: "",
      comment: "",
      qty: "",
      category_id: "",
      sku: "",
    });
    setLgShow(true);
  };

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    !!store.id && setData2(store.categories);
  }, [store]);

  useEffect(() => {
    async function fetchTemplates() {
      try {
        setIsLoading(true);
        // Add a small delay to show the loading animation
        await new Promise((resolve) => setTimeout(resolve, 800));

        const response = await axios.get(
          `https://foorai.foorweb.store/api/projects?page=1&limit=1000&userFoorweb=${store?.user}`,
        );
        setTemplates(response.data.data);
      } catch (error) {
        console.error(t("foorAi.errors.fetch_templates_failed"), error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchTemplates();
  }, [store]);

  const goToEditor = (data) => {
    console.log(data.id);

    navigate("/foorai/editor", {
      state: {
        data,
        user: account?.user,
      },
    });
  };

  // Add this state in your main component
  const [openDropdown, setOpenDropdown] = useState(null);

  // Add this useEffect to handle clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openDropdown && !event.target.closest(".dropdown-container")) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdown]);

  // Handle menu actions
  const handleMenuAction = (action, template, e) => {
    e.stopPropagation(); // Prevent card click
    setOpenDropdown(null);

    if (action === "delete") {
      // Add your delete logic here
      console.log("Delete template:", template.id);
      // You can show a confirmation dialog here
    } else if (action === "update") {
      // Add your update logic here
      console.log("Update template:", template.id);
    }
  };

  // Handle dropdown toggle
  const handleDropdownToggle = (templateId, e) => {
    e.stopPropagation(); // Prevent card click
    setOpenDropdown(openDropdown === templateId ? null : templateId);
  };

  const handleGenerateLandingPage = async (payload) => {
    if (payload?.__clientError === "INSUFFICIENT_TOKENS") {
      Swal.fire({
        icon: "warning",
        title: t("foorAi.errors.insufficient_title"),
        text: t("foorAi.errors.insufficient_text", { cost: 40 }),
        confirmButtonColor: "#9b59bf",
      });
      return;
    }

    setIsGenerating(true);
    try {
      const formData = new FormData();

      if (payload.user) {
        formData.append("user", payload.user);
      } else if (account?.user) {
        formData.append("user", account.user);
      }

      if (payload.product_image) {
        formData.append("product_image", payload.product_image);
      }
      formData.append("product_name", payload.product_name || "");
      formData.append("product_price", payload.product_price || "");
      formData.append("generation_prompt", payload.generation_prompt || "");
      formData.append(
        "generation_language",
        payload.generation_language || "ar-DZ",
      );
      if (payload.product_id) {
        formData.append("product_id", payload.product_id);
      }

      const currentUser = auth.currentUser;
      if (!currentUser) {
        throw new Error(t("foorAi.errors.login_required"));
      }
      const idToken = await currentUser.getIdToken(true);

      const response = await axios.post(GENERATE_LANDING_ENDPOINT, formData, {
        headers: { Authorization: `Bearer ${idToken}` },
        timeout: 5 * 60 * 1000,
      });

      if (!response.data?.ok || !response.data?.product) {
        throw new Error(
          response.data?.error || t("foorAi.errors.generate_failed"),
        );
      }

      // sync tokens after nest debit (−40)
      if (response.data?.billing) {
        const b = response.data.billing;
        dispatch(
          updateAccount({
            subscription: {
              ...(account.subscription || {}),
              tokens:
                typeof b.tokens === "number"
                  ? b.tokens
                  : account.subscription?.tokens,
              ...(typeof b.freeRemaining === "number"
                ? { aiProductPageFreeRemaining: b.freeRemaining }
                : {}),
              ...(b.monthKey ? { aiProductPageFreeMonth: b.monthKey } : {}),
            },
          }),
        );
      }

      const generated = response.data.product;

      const newProduct = {
        url: generated.url || "",
        name: generated.name || "",
        image: generated.image || "",
        review: "",
        price: String(generated.price || ""),
        oldPrice: "",
        comment: "",
        qty: "",
        category_id: "كل المنتجات",
        short: "",
        sku: generated.sku || "",
        show: "1",
        options: [
          {
            title: "",
            color: "",
            option1: "",
            option2: "",
            option3: "",
            option4: "",
          },
        ],
        offers: [
          { title: "", qty: 0, price: 0 },
          { title: "", qty: 0, price: 0 },
          { title: "", qty: 0, price: 0 },
          { title: "", qty: 0, price: 0 },
        ],
        discount: {
          freeDelivery: false,
          discountDelivery: 0,
          discountTotal: 0,
        },
        gallery: generated.gallery || [],
        textEditor: generated.textEditor || "<p><br></p>",
        landingImage: generated.landingImage || "",
        timeStamp: serverTimestamp(),
        created_via: "FoorAiLandingPageGenerator",
      };

      const result = await dispatch(addMultipleProducts([newProduct]));
      if (!result) throw new Error(t("foorAi.errors.add_product_failed"));
      return response.data;
    } catch (err) {
      console.error("Error generating landing page:", err);

      const isInsufficient =
        err?.response?.status === 402 ||
        err?.response?.data?.code === "INSUFFICIENT_TOKENS" ||
        String(err?.message || "").includes("INSUFFICIENT");

      const isNetwork =
        err?.code === "ERR_NETWORK" ||
        err?.message === "Network Error" ||
        !err?.response;

      const isTimeout =
        err?.code === "ECONNABORTED" ||
        String(err?.message || "")
          .toLowerCase()
          .includes("timeout");

      const isServer = err?.response?.status >= 500;

      let code = "GENERIC";
      if (isInsufficient) code = "INSUFFICIENT_TOKENS";
      else if (isNetwork) code = "NETWORK";
      else if (isTimeout) code = "TIMEOUT";
      else if (isServer) code = "SERVER";

      const mapped = new Error(code);
      mapped.code = code;
      throw mapped;
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={i18n.dir()}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          <div className="bg-white rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1  dark:text-[#c88ef2]">
                  {t("foorAi.projectCenter.header.title")}
                </h2>
                <p className="text-gray-600 mb-0 dark:text-gray-400">
                  {t("foorAi.projectCenter.header.subtitle")}
                </p>
              </div>
              <button
                onClick={!!account.store ? () => setAiModalShow(true) : message}
                className="px-4 py-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white font-medium rounded-lg inline-flex items-center transition-colors gap-2 dark:bg-[#814a9f] dark:hover:bg-[#9b59bf]"
              >
                <Plus size={18} />
                {t("foorAi.projectCenter.header.buttonNewProject")}
              </button>
            </div>
          </div>

          <div className="mx-3 mb-3 flex items-center justify-between">
            <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-purple-100 dark:!border-[#3c3a3d] overflow-hidden">
              <div className="flex">
                <button
                  type="button"
                  className={`px-6 py-3 text-sm font-medium transition-all duration-200 ${
                    activeTab === "landing"
                      ? "bg-[#faf1ff] text-[#9e65bb] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#9b59bf] shadow-sm"
                      : "text-gray-600 hover:bg-purple-50 hover:text-[#9e68ba] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => setActiveTab("landing")}
                >
                  {t("foorAi.tabs.landing")}
                </button>
                <button
                  type="button"
                  className={`px-6 py-3 text-sm font-medium transition-all duration-200 ${
                    activeTab === "history"
                      ? "bg-[#faf1ff] text-[#9e65bb] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#9b59bf] shadow-sm"
                      : "text-gray-600 hover:bg-purple-50 hover:text-[#9e68ba] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => setActiveTab("history")}
                >
                  {t("foorAi.tabs.history")}
                </button>
              </div>
            </div>
          </div>

          {activeTab === "landing" && (
            <>
              {/* Hero — centered headline + stacked landing-page preview */}
              <div className="bg-white rounded-xl shadow-sm m-3 border border-[#fbf4ff] overflow-hidden dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                <section className="relative max-w-screen-xl mx-auto py-10 px-4 md:px-8 text-center">
                  <div className="flex justify-center mb-4">
                    <Sparkles className="w-7 h-7 text-[#9e68ba] dark:text-[#c88ef2]" />
                  </div>

                  <h3 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-3">
                    {t(
                      "foorAi.projectCenter.hero.titleMain",
                      "أسرع طريقة لإطلاق علامتك التجارية",
                    )}
                  </h3>

                  <p className="text-gray-600 dark:text-gray-400 max-w-xl mx-auto mb-6">
                    {t(
                      "foorAi.projectCenter.hero.descriptionMain",
                      "أنشئ صفحات هبوط احترافية ومُحسّنة للتحويل في ثوانٍ",
                    )}
                  </p>

                  <button
                    onClick={
                      !!account.store ? () => setAiModalShow(true) : message
                    }
                    className="px-6 py-2.5 border border-[#9b59bf] text-[#9b59bf] hover:bg-[#fcf6ff] font-medium rounded-full inline-flex items-center gap-2 transition-colors dark:!border-[#3c3a3d] dark:text-[#c88ef2] dark:hover:bg-[#2a2a2c] mb-10"
                  >
                    {t(
                      "foorAi.projectCenter.hero.buttonGenerate",
                      "أنشأ صفحة الهبوط",
                    )}
                    <Wand2 size={16} />
                  </button>

                  <div className="relative bg-gradient-to-b from-purple-50 to-purple-100 dark:from-[#2a2a2c] dark:to-[#3a2a3f] rounded-xl overflow-hidden pt-10 pb-6 px-4">
                    <div className="flex justify-center items-end gap-0">
                      <HeroMockupCard
                        rotate={-6}
                        z={10}
                        className="hidden sm:block -mr-8 mb-3"
                      />
                      <HeroMockupCard
                        rotate={0}
                        z={20}
                        emphasize
                        className="scale-110"
                      />
                      <HeroMockupCard
                        rotate={6}
                        z={10}
                        className="hidden sm:block -ml-8 mb-3"
                      />
                    </div>
                  </div>
                  {/* <div className="">
                    <img
                      src="/landingpageAi.png"
                      alt="Foorweb Landing Page"
                      className="w-full h-auto mx-auto"
                    />
                  </div> */}
                </section>
              </div>

              <div className="p-4">
                <div className="mx-3 bg-white rounded-xl shadow-sm border border-purple-100 dark:!border-[#3c3a3d] p-0 mb-6 overflow-hidden">
                  <AiGeneratedProductsTable
                    setLgShow={setLgShow}
                    setData={setData}
                  />
                </div>
              </div>
            </>
          )}

          {activeTab === "history" && (
            <div className="p-4 mx-3 mb-6">
              <AiGenerationHistory />
            </div>
          )}

          <Footer />
        </div>
      </div>
      <ProductExportModal
        isOpen={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
      />

      <AILandingPageModal
        show={aiModalShow}
        setShow={setAiModalShow}
        isGenerating={isGenerating}
        existingProducts={products}
        onGenerate={handleGenerateLandingPage}
      />

      <ModelAdd
        lgShow={lgShow}
        setLgShow={setLgShow}
        data={data}
        setData={setData}
        categories={data2}
        hideProductDescription
      />
      <ModelShow lgShow={modelShow} setLgShow={setModelShow} images={images} />

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .image-hover-overlay::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 0;
          background: rgba(255, 255, 255, 0.5);
          transition: height 0.3s ease;
          z-index: 10;
        }

        .group:hover .image-hover-overlay::after {
          height: 100%;
        }

        .overlay-content {
          position: absolute;
          inset: 0;
          z-index: 20;
          opacity: 0;
          transition: opacity 0.3s ease 0.15s;
        }

        .group:hover .overlay-content {
          opacity: 1;
        }
      `}</style>
    </div>
  );
}

export default Products;
